import React from "react";
import { Typography, Badge } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  ItemCard,
  ItemHeader,
  ItemRank,
  ItemInfo,
  ItemName,
  BadgeContainer,
  TrendContainer,
  TrendValue,
  StatsGrid,
  StatItem,
  StatLabel,
  StatValue,
  ProgressContainer,
  ProgressLabel,
  StyledProgress,
  GrowthContainer,
  ItemHeaderFlex,
  StatItemEnd,
  RevenueStatValue,
  SmallTrendValue,
  IconWrapper,
} from "./styles";
import { TrendingItemCardProps } from "./types";
import {
  getTrendBadgeColor,
  trendLabels,
  trendIconConfig,
  TrendType,
} from "./constants";

const { Text } = Typography;

const TrendingItemCard: React.FC<TrendingItemCardProps> = ({ item, index }) => {
  const getTrendIcon = (trend: TrendType): React.ReactElement => {
    const config = trendIconConfig[trend];
    return (
      <IconWrapper color={config.color}>
        <FontAwesomeIcon icon={config.icon} />
      </IconWrapper>
    );
  };

  return (
    <ItemCard>
      <ItemHeader>
        <ItemHeaderFlex>
          <ItemRank>#{index + 1}</ItemRank>
          <ItemInfo>
            <ItemName strong>{item.item}</ItemName>
            <BadgeContainer>
              <Badge color="blue" text={item.categoryName} />
              <Badge
                status={getTrendBadgeColor(item.trend)}
                text={trendLabels[item.trend]}
              />
            </BadgeContainer>
          </ItemInfo>
        </ItemHeaderFlex>
        <TrendContainer>
          {getTrendIcon(item.trend)}
          <TrendValue trend={item.trend}>
            {item.volumeGrowth > 0 ? "+" : ""}
            {item.volumeGrowth}%
          </TrendValue>
        </TrendContainer>
      </ItemHeader>

      <StatsGrid>
        <StatItem>
          <StatLabel>Times Sold</StatLabel>
          <StatValue>{item.totalTimesSold.toLocaleString()}</StatValue>
        </StatItem>
        <StatItemEnd>
          <StatLabel>Revenue</StatLabel>
          <RevenueStatValue>
            ${item.totalRevenue.toLocaleString()}
          </RevenueStatValue>
        </StatItemEnd>
      </StatsGrid>

      <ProgressContainer>
        <ProgressLabel>
          <StatLabel>Popularity Score</StatLabel>
          <Text strong>{item.popularityScore}/100</Text>
        </ProgressLabel>
        <StyledProgress
          percent={item.popularityScore}
          strokeColor={{
            "0%": "#1890ff",
            "100%": "#722ed1",
          }}
          size="small"
        />
      </ProgressContainer>

      <GrowthContainer>
        <StatItem>
          <StatLabel>Revenue Growth</StatLabel>
          <SmallTrendValue trend={item.trend}>
            {item.revenueGrowth > 0 ? "+" : ""}
            {item.revenueGrowth}%
          </SmallTrendValue>
        </StatItem>
        <StatItemEnd>
          <StatLabel>Previous Period</StatLabel>
          <Text>{item.previousPeriod?.totalTimesSold || 0} sold</Text>
        </StatItemEnd>
      </GrowthContainer>
    </ItemCard>
  );
};

export default TrendingItemCard;
